import { Platform } from 'react-native'
import { useWindowDimensions } from './util'

const useFontSize = () => {
  const viewPortWidth = useWindowDimensions()
  const isMobile = viewPortWidth < 600
  return isMobile ? fontMobile : fontDesktop
}

export const useIsMobile = () => {
  const viewPortWidth = useWindowDimensions()
  const isMobile = viewPortWidth < 600

  if (Platform.OS !== 'web') {
    return false
  }
  return isMobile
}

const fontMobile = {
  headerSize: 24,
  subHeaderSize: 18,
  textSize: 16,
}

const fontDesktop = {
  headerSize: 48,
  subHeaderSize: 24,
  textSize: 18,
}

export default useFontSize
